import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
// import parkingpayments from '../../assets/img/parkingpayments.png'
// import townsend from '../../assets/img/townsend.png'
// import logos from '../../assets/img/logos.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
import { getPartnerDetails, getPartnerLogo, loggedInUserData } from '../../utils/helper'


// import URL from '../../constants/urls'

function MiniHeader(props) {

    const { isDisplayBack, title, className, noLoginIcon,isAddIcon, handleAdd,
        // isDisplayLogo,
        partnerdetails } = props

    const partner = window.location.toString().split('/')[3]
    // const [loggedInUserData, setLogedInUserData] = useState(EMPTY_OBJECT)
    const navigate = useNavigate()
    const location = useLocation()

    // useEffect(() => {
    //     // if (!loginData?.access_token || loginData?.access_token == '') {
    //     //     const loginData = JSON.parse(localStorage.getItem('sign_in') ? localStorage.getItem('sign_in') : localStorage.getItem('sign_up') ? localStorage.getItem('sign_up') : '{}')
    //     //     // setLogedInUserData(loginData)
    //     // } else {
    //     //     // setLogedInUserData(loginData)
    //     // }

    // }, [loginData, window.location.pathname])

    const handleBackClick = () => {
        if(location?.pathname?.includes('payment-list') || location?.pathname?.includes('vehicle-list')){
            navigate(`/${partner}/menu`)
        }else if(location?.key != 'default'){
            navigate(-1)
        }
    }
    const handleLogin = () => {
        navigate(`/${partner}/login`)
    }

    const handleHomeLoad = () => {
        const history = JSON.parse(localStorage.getItem('history'))
        if(location?.pathname?.includes('extend')) {
            window.location.reload()
        } else{
            navigate(`/${partner}/${history?.route}/${history?.facility}`)
        }
    }

    const handleLoginProfile = () => {
        navigate(`/${partner}/menu`)
    }


    return (
        
        <div className={`${className ? className : ''}  container-fluid py-3 border-bottom  border-primary`}>
            <div className='row g-0 align-items-center justify-content-between'>

            {isDisplayBack && <div className='col-auto'><a onClick={() => handleBackClick()} className='btn btn-sm'> <i className='fa fa-angle-left me-2 text-primary' ></i></a></div>}
            
            {/* {isDisplayLogo &&  */}
            <div className='col-3'> <img
                onClick={() => handleHomeLoad()}
                // className='w-100'
                style={{height:'30px'}}
                // src={partner == 'parkingpayments' ? parkingpayments : partner == 'townsend' ? townsend : logos}
                src={partner ? partnerdetails ? partnerdetails?.brand_setting?.logourl : getPartnerDetails()?.brand_setting?.logourl : getPartnerLogo('parkengage')}
                alt={partner ? partner : 'e-Ticket'}
            /></div>
            {/* } */}
            <div className={'col text-center pt-1 text-primary'}>
                <h6>{title}</h6>
            </div>
            <div className='col-auto text-end d-inline-block'>
                {/* {(!noLoginIcon) ? loggedInUserData()?.access_token ? <>{isAddIcon && <i className='far fa-add text-primary ms-2 me-2 fa-lg' onClick={handleAdd} ></i>} <i className='far fa-user-circle text-primary fa-lg' onClick={handleLoginProfile} ></i></> : <i className="fa fa-sign-in text-primary fa-lg" onClick={handleLogin}></i> : null} */}
                {partner && (!noLoginIcon) ? loggedInUserData()?.access_token ? <>{isAddIcon && <span className='d-inline-block ms-2 me-2' style={{ height: '25px', width: '25px' }} onClick={handleAdd}>{getSvgIcon('add_user', 'var(--bs-primary)')}</span>} <span  className='d-inline-block' style={{ height: '25px', width: '25px' }} onClick={handleLoginProfile}>{getSvgIcon('USER', 'var(--bs-primary)')}</span></> : <span className='d-inline-block' style={{ height: '25px', width: '25px' }} onClick={handleLogin}>{getSvgIcon('login', 'var(--bs-primary)')}</span> : null}
            </div>
        </div>
        </div>
       
    )
}

MiniHeader.propTypes = {
    isDisplayBack: PropTypes.bool,
    title: PropTypes.string,
    loginData: PropTypes.object,
    className: PropTypes.string,
    noLoginIcon: PropTypes.bool,
    isAddIcon: PropTypes.bool,
    handleAdd: PropTypes.func,
    isInVehicleList: PropTypes.bool,
    isInAddVehicle: PropTypes.bool,
    isDisplayLogo: PropTypes.bool,
    partnerdetails: PropTypes.object,
}

MiniHeader.defaulProps = {
    isDisplayBack: false,
    title: '',
    loginData: EMPTY_OBJECT,
    className: '',
    noLoginIcon: false,
    isAddIcon: false,
    handleAdd: noop,
    isInVehicleList: false,
    isInAddVehicle: false,
    isDisplayLogo: false,
    partnerdetails: EMPTY_OBJECT,
}

function mapStateToProps({ transientReducer }) {
    return {
        loader: transientReducer?.loader,
        isFetching: transientReducer?.isFetching
    }
}

export default connect(mapStateToProps)(MiniHeader)